import React, { Component, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'

import { Detail as CustomerCompany } from "@/views/base/company/Detail";
import { useForm, SubmitHandler, useWatch } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";
import {FieldHolder} from "@/components/holders/FieldHolder";
import { useModel } from "@/models/base/useModel";
import { CompanyDetail } from "../Paperchip/Company/CompanyDetail";
export function Detail({...props}) {
  const detailRef = useRef(null);
  const {tm} = useModel('name', props.data);

  // const { register, handleSubmit, watch, reset,  control,  formState, setValue, getValues } = useForm({
  //     defaultValues: props.data,
  //     values: props.data
  //   })
    //setValue("type", props.data.type.toString() );
// const watchedValue = useWatch({
//     control: control,
//   compute: (data: any) => { 
//     

    


//     return data; 

//     return ''; 
//   }, 
// });


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

//    const onSubmit: SubmitHandler = (data) => {
// //    event.preventDefault();
// //    event.stopPropagation();
// // 
//     props.onSaveHandler(data);
//     // detailRef.current.getData();
//     console.debug("save handler", data.getData());
      
//     return false;

//     }
/*
  React.useEffect(() => {
      if(props.data && watch("key") != props.data.key) {
          reset(props.data);
      } else if(!props.data && formState.defaultValues && formState.defaultValues["key"] && formState.defaultValues["key"] != "") {
            for (const [key, value] of Object.entries(formState.defaultValues)) {
                formState.defaultValues[key] = "";
            }          
            reset(formState.defaultValues, { keepDirtyValues: true }); 
      }
  }, [formState, reset])
*/

  // const onSaveWrapped = (data) => {
  //   event.preventDefault();
  //   event.stopPropagation();
    
    
  //   //props.onSaveHandler(data);
      
  //   return false;
  // };
  
  return (
    <>


    <div className="">
      <CompanyDetail />
    </div>



    </>
      );
}
